var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-server-table", {
    ref: "table",
    staticClass: "vue-custom-table no-pagination vue-custom-table-infinite",
    attrs: {
      columns: _vm.tableOptions.columns,
      options: _vm.tableOptions.options,
    },
    on: { loading: _vm.handleTableLoading, loaded: _vm.handleTableLoaded },
    scopedSlots: _vm._u([
      {
        key: "select",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "form-group-checkbox" }, [
              _c("div", { staticClass: "p-default p-round m-0" }, [
                _c("input", {
                  attrs: {
                    id: "select-agent-" + row.agentUsername,
                    name: "select-agent",
                    type: "radio",
                  },
                  domProps: { value: _vm.isAgentSelected(row) },
                  on: {
                    change: function ($event) {
                      return _vm.handleSelectAgent(row)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "d-none",
                    attrs: { for: "select-agent-" + row.agentUsername },
                  },
                  [_vm._v(_vm._s(row.agentFullName))]
                ),
              ]),
            ]),
          ]
        },
      },
      {
        key: "name",
        fn: function (ref) {
          var row = ref.row
          return [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c(
                  "profile-avatar",
                  _vm._b(
                    {
                      staticClass: "client-avatar mr-2 d-none d-lg-inline",
                      attrs: { "profile-photo": "" },
                    },
                    "profile-avatar",
                    _vm.formatAgentForAvatar(row),
                    false
                  )
                ),
                _vm._v("\n      " + _vm._s(row.agentFullName) + "\n    "),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "brokerage",
        fn: function (ref) {
          var row = ref.row
          return [_vm._v("\n    " + _vm._s(row.brokerageName) + "\n  ")]
        },
      },
      {
        key: "address",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm._v("\n    " + _vm._s(_vm.fullAddress(row.address)) + "\n  "),
          ]
        },
      },
      {
        key: "favorite",
        fn: function (ref) {
          var row = ref.row
          return [
            _c(
              "div",
              { staticClass: "btn-group" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-flat star-client",
                    attrs: {
                      "aria-label": "favoriteButton",
                      title: "favoriteButton",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleFavoriteAgent(row)
                      },
                    },
                  },
                  [
                    _c("icon", {
                      attrs: {
                        "icon-class": "text-primary",
                        name: row.isFavorite ? "star" : "star-o",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }